import { ReactElement } from 'react';

interface RTACRectangleProps {
  label: string;
  xCoordinate: number;
  yCoordinate: number;
  labelXCoordinate: number;
  labelYCoordinate: number;
  fillColor: string;
  textAnchor: string;
}

export default function RTACRectangle({
  label,
  xCoordinate,
  yCoordinate,
  labelXCoordinate,
  labelYCoordinate,
  fillColor,
  textAnchor = 'right',
}: RTACRectangleProps): ReactElement {
  return (
    <>
      <rect
        x={xCoordinate}
        y={yCoordinate}
        width='20'
        height='20'
        fill={fillColor}
        strokeWidth={0.5}
      />
      <text
        x={labelXCoordinate}
        y={labelYCoordinate}
        fill='currentColor'
        stroke='none'
        textAnchor={textAnchor}
        fontSize='8px'
      >
        {label}
      </text>
    </>
  );
}
